import React, { FC } from 'react';
import { Label } from '@atlaskit/form';
import Select from '@atlaskit/select';

import { ValueLabel } from '../../../components/config/options-adder/interfaces';

type Props = {
    onChange: (value: string) => void;
    options: ValueLabel[];
    value: string;
};

const MultilevelFieldSelect: FC<Props> = ({ value, onChange, options }) => {
    return (
        <div>
            <Label htmlFor='mlv-field-select'>Choose Multilevel select custom field</Label>
            <Select
                value={options.find(option => option.value === value)}
                options={options}
                onChange={selectedOption => onChange(selectedOption?.value || '')}
                id='mlv-field-select'
                testId='mlv-field-select'
            />
        </div>
    );
};

export default MultilevelFieldSelect;
